import React from 'react';
import './PC.css';
import BritishTelecom from '../../img/PC/BritishTelecom.png'
import Grigorescu from '../../img/PC/Grigorescu.png'
import Pattanaik from '../../img/PC/Pattanaik.png'
import sevensphere from '../../img/PC/sevensphere.svg'
import Zarouali from '../../img/PC/Zarouali.png'
import Valenzuela from '../../img/PC/Valenzuela.png'
import Farcic from '../../img/PC/Farcic.png'
import Sharma from '../../img/PC/Sharma.png'
import Tamegue from '../../img/PC/Tamegue.png'
import Garnier from '../../img/PC/Garnier.png'
import Viswanathan from '../../img/PC/Viswanathan.png'
import RedHat from '../../img/PC/RedHat.png'

export default class PC extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pc: [
        {
          photo: Zarouali,
          name: 'Rachid Zarouali',
          position: 'Cloud Architect',
          ln: 'https://linkedin.com/in/rachidzarouali',
          tw: 'https://twitter.com/xinity',
          github: 'https://github.com/xinity',
          logo: sevensphere,
        },
        {
          photo: Pattanaik,
          name: 'Subhasish Pattanaik',
          position: 'Test Manager',
          ln: 'https://www.linkedin.com/in/subhasishpattanaik/',
          logo: BritishTelecom,
        },
        {
          photo: Grigorescu,
          name: 'Bogdan Grigorescu',
          position: 'Head of QA',
          ln: 'https://www.linkedin.com/in/bogdan-g/',
        },
        {
          photo: Valenzuela,
          name: 'Jorge Valenzuela',
          position: 'Senior Manager App Innovation',
          ln: 'https://www.linkedin.com/in/jorge-valenzuela-jimenez',
          tw: 'https://twitter.com/jj_tel',
          github: 'https://github.com/jovalen',
        },
        {
          photo: Farcic,
          name: 'Viktor Farcic',
          position: 'Developer Advocate',
          tw: 'https://twitter.com/vfarcic',
        },
      ],
      pcHide: [
        {
          photo: Sharma,
          name: 'Rushil Sharma',
          position: 'Specialist Customer Engineer',
          ln: 'https://www.linkedin.com/in/rushil-kube/',
        },
        {
          photo: Tamegue,
          name: 'Jules Saurel Pericles Tamegue',
          position: 'Devops/Cloud Engineer',
          ln: 'https://www.linkedin.com/in/julessaurel/',
        },
        {
          photo: Garnier,
          name: 'Jeremie Garnier',
          position: 'Site Reliability Engineering Manager',
          ln: 'https://www.linkedin.com/in/jeremie-garnier-4bab1019/',
          tw: 'https://twitter.com/jgarnier19',
        },
        {
          photo: Viswanathan,
          name: 'Ompragash Viswanathan',
          position: 'Senior Software Engineer',
          ln: 'https://www.linkedin.com/in/ompragash/',
          tw: 'https://twitter.com/ompragash_v',
          github: 'https://github.com/Ompragash',
          yb: 'https://youtube.com/c/opensourceops',
        },
      ],
      hide: true,
    }
    this.togglePC = this.togglePC.bind(this);
  }

  togglePC() {
    this.setState({ hide: !this.state.hide });
  }

  renderPC(item, i) {
    return (
      <div className="pc_item" key={`team-${i}`}>
        <div className="pc_img_block">
          <img className="pc_img" src={item.photo} alt={item.name} />
        </div>
        <div className="pc_info">
          <p className="pc_name">{item.name}</p>
          <p className="pc_position">{item.position}</p>
          <div className="pc_links">
            {item.fb && <a className="pc_link social_fb" target='_blank' rel='noreferrer' href={item.fb}></a>}
            {item.ln && <a className="pc_link social_ln" target='_blank' rel='noreferrer' href={item.ln}></a>}
            {item.tw && <a className="pc_link social_tw" target='_blank' rel='noreferrer' href={item.tw}></a>}
            {item.github && <a className="pc_link social_github" target='_blank' rel='noreferrer' href={item.github}></a>}
            {item.website && <a className="pc_link social_website" target='_blank' rel='noreferrer' href={item.website}></a>}
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="pc" id='pc'>
        <div className='container team_wrap'>
          <h2>Program committee</h2>
          <div className="pc_block">
            {this.state.pc.map((item, i) => this.renderPC(item, i))}
            {!this.state.hide && this.state.pcHide.map((item, i) => this.renderPC(item, i))}
          </div>
          <button className='pc_btn' onClick={this.togglePC}>{this.state.hide ? 'Show more' : 'Hide'}</button>
        </div>
      </div>
    )
  }
}